export const STEPPER_ORIENTATIONS = {
    horizontal: 'horizontal',
    vertical: 'vertical',
} as const
